import ApiService from "./api-service";

const endpoint = "/products";

export default class ProductService {
  static async getProducts(params) {
    return await ApiService.get(endpoint, params);
  }

  static async getProductsWithAdvancedSearch(params) {
    // ?color=blue;green;yellow&model=s360;x45&size=small:extraSmall&price=100
    // ?brand=sony:sharp&price=100:200
    // ?price=100&exactPriceMath=1&pattern=or
    // ?...&relatedFields=category,images,inventory
    return await ApiService.get(`${endpoint}/search/advanced`, params);
  }

  static async getProduct(productId, params) {
    return await ApiService.get(`${endpoint}/:productId`, {
      ...(params ?? {}),
      productId
    });
  }

  // Not needed. getProduct already fills the role
  // because the backend auto fetches from product variants collection
  // if a product with the productId passed to getProduct is not found
  /*
  static async getProductVariant(variantId, params) {
    return await ApiService.get(`${endpoint}/variants/:variantId`, {
      ...(params ?? {}),
      variantId
    });
  }*/

  static async addProductReview(productId, reviewData) {
    const { author, body, rating, target } = reviewData;

    return await ApiService.post(`${endpoint}/${productId}/reviews`, undefined, {
      author,
      body,
      rating,
      target
    });
  }

  static async getProductReviews(productId, params) {
    return await ApiService.get(`${endpoint}/:productId/reviews`, {
      ...(params ?? {}),
      productId
    });
  }
}
